(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kk-at-a-glance"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--aag');
  if (!sectionEl) return;
  var items = sectionEl.querySelectorAll('[data-kk-aag-item]');
  if (!items.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealItems() {
    items.forEach(function(item, i) {
      setTimeout(function() {
        item.classList.add('kk-aag__item--visible');
      }, 300 + (i * 100));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealItems();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealItems();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* v2.17: Dots-Indikator fuer die mobile Fakten-Reihe - nur bei echtem Overflow, nicht klickbar */
(function() {
  var grid = document.querySelector('.kk-aag__grid');
  var dotsWrap = document.querySelector('.kk-aag__dots');
  if (!grid || !dotsWrap) return;
  var items = grid.querySelectorAll('.kk-aag__item');
  if (items.length < 2) return;

  var dots = [];
  function update() {
    if (!dots.length) return;
    var step = items[0].offsetWidth || 1;
    var max = grid.scrollWidth - grid.clientWidth;
    var idx = Math.round(grid.scrollLeft / step);
    if (max > 0 && grid.scrollLeft >= max - 8) idx = items.length - 1;
    idx = Math.max(0, Math.min(items.length - 1, idx));
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('kk-aag__dot--on', i === idx);
  }
  function build() {
    var overflow = grid.scrollWidth > grid.clientWidth + 4;
    if (!overflow) { dotsWrap.style.display = 'none'; return; }
    dotsWrap.style.display = '';
    if (!dots.length) {
      for (var i = 0; i < items.length; i++) {
        var d = document.createElement('span');
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }
    update();
  }
  var ticking = false;
  grid.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });
  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(build, 200);
  });
  build();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-compare"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--comp');
  if (!sectionEl) return;
  var rows = sectionEl.querySelectorAll('[data-kk-comp-row]');
  if (!rows.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealRows() {
    rows.forEach(function(row, i) {
      setTimeout(function() {
        row.classList.add('kk-comp__row--visible');
      }, 300 + (i * 100));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealRows();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealRows();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-content-block"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.kk-section--cb');
  if (!sections.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        setTimeout(function() { el.classList.add('kk-cb--animated'); }, 1000);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.3 });
  sections.forEach(function(s) { observer.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-cross-sell"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--cross');
  if (!sectionEl) return;
  var cards = sectionEl.querySelectorAll('[data-kk-cross-card]');
  if (!cards.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* === Staggered Reveal: Reagiert auf globalen Scroll-Reveal (kk-visible) === */
  if (prefersReduced) {
    /* Sofort sichtbar, CSS handled via !important */
  } else {
    /* Pruefe ob Section schon sichtbar (z.B. above the fold oder Seitenrueckkehr) */
    if (sectionEl.classList.contains('kk-visible')) {
      revealCards();
    } else {
      /* MutationObserver: Wartet bis der globale Scroll-Reveal kk-visible setzt */
      var mo = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (sectionEl.classList.contains('kk-visible')) {
            revealCards();
            mo.disconnect();
            return;
          }
        }
      });
      mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function revealCards() {
    cards.forEach(function(card, i) {
      setTimeout(function() {
        card.classList.add('kk-cross__card--visible');
      }, 400 + (i * 120));
    });
  }

  /* === Quick-Add mit Erfolgs-Feedback === */
  var forms = sectionEl.querySelectorAll('[data-kk-cross-form]');
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.kk-cross__add-btn');
      if (btn.classList.contains('kk-cross__add-btn--success')) return;

      var body = 'id=' + encodeURIComponent(form.querySelector('[name="id"]').value) + '&quantity=1';

      fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function(res) {
        if (res.ok) {
          /* Checkmark anzeigen */
          btn.classList.add('kk-cross__add-btn--success');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

          /* Cart-Counter aktualisieren (Impact Theme) */
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch(err) {}

          /* Nach 2s zuruecksetzen */
          setTimeout(function() {
            btn.classList.remove('kk-cross__add-btn--success');
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
          }, 2000);
        }
      }).catch(function() {
        /* Fallback: Normales Form-Submit */
        form.submit();
      });
    });
  });

  /* === Mobile: Scroll-Fade am Ende ausblenden === */
  var grid = sectionEl.querySelector('.kk-cross__grid');
  var wrap = sectionEl.querySelector('.kk-cross__grid-wrap');
  if (wrap && grid && window.innerWidth <= 749) {
    grid.addEventListener('scroll', function() {
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
      wrap.classList.toggle('kk-cross__grid-wrap--scrolled-end', atEnd);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-food-compare"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--food');
  if (!sectionEl) return;
  var parts = sectionEl.querySelectorAll('[data-kk-food-part]');
  if (!parts.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  /* Drei Akte: Food (300ms) -> Divider (500ms) -> Hero (650ms) */
  var delays = [300, 500, 650];

  function revealParts() {
    parts.forEach(function(part, i) {
      setTimeout(function() {
        part.classList.add('kk-food--visible');
      }, delays[i] || 300 + (i * 150));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealParts();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealParts();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-general-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var items = document.querySelectorAll('.kk-section--gfaq .kk-gfaq__item');
  if (!items.length) return;
  items.forEach(function(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;

    // first_open (server-gerendert): sofort sichtbar, kein Flash
    if (details.open) {
      summary.setAttribute('aria-expanded', 'true');
      details.classList.add('kk-gfaq__item--reveal');
    }

    // Native <details> oeffnet/schliesst die Hoehe SOFORT (1 Reflow, kein Per-Frame-Layout).
    // 'toggle' synct aria + blendet den Inhalt per GPU ein (--reveal 2 Frames spaeter).
    details.addEventListener('toggle', function() {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            if (details.open) details.classList.add('kk-gfaq__item--reveal');
          });
        });
      } else {
        details.classList.remove('kk-gfaq__item--reveal');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-good-to-know"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* --- Scoped Table Scroll Wrapper --- */
  var sectionEl = document.querySelector('.kk-section--gtk');
  var root = sectionEl ? sectionEl.querySelector('.kk-gtk') : null;
  if (!root) return;

  requestAnimationFrame(function() {
    var tables = root.querySelectorAll('.kk-gtk__content table');
    tables.forEach(function(table) {
      if (table.parentNode.classList.contains('kk-gtk__table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'kk-gtk__table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  });

  /* --- Article Reveal (identisches Pattern wie kk-product-compare) --- */
  var articles = sectionEl.querySelectorAll('[data-kk-gtk-article]');
  if (!articles.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealArticles() {
    articles.forEach(function(article) {
      article.classList.add('kk-gtk__article--visible');
    });
  }

  /* Customizer: sofort sichtbar */
  if (window.Shopify && window.Shopify.designMode) {
    revealArticles();
    return;
  }

  /* Standard: warte auf kk-visible vom Custom Liquid Block */
  if (sectionEl.classList.contains('kk-visible')) {
    revealArticles();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealArticles();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-nutrition"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--nut');
  if (!sectionEl) return;
  var cards = sectionEl.querySelectorAll('[data-kk-nut-card]');
  if (!cards.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealCards() {
    cards.forEach(function(card, i) {
      setTimeout(function() {
        card.classList.add('kk-nut__card--visible');
      }, 300 + (i * 200));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealCards();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealCards();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-product-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var items = document.querySelectorAll('.kk-section--faq .kk-faq__item');
  if (!items.length) return;
  items.forEach(function(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;

    // first_open (server-gerendert): sofort sichtbar, kein Flash
    if (details.open) {
      summary.setAttribute('aria-expanded', 'true');
      details.classList.add('kk-faq__item--reveal');
    }

    // Native <details> oeffnet/schliesst die Hoehe SOFORT (1 Reflow, kein Per-Frame-Layout).
    // 'toggle' synct aria + blendet den Inhalt per GPU ein (--reveal 2 Frames spaeter).
    details.addEventListener('toggle', function() {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            if (details.open) details.classList.add('kk-faq__item--reveal');
          });
        });
      } else {
        details.classList.remove('kk-faq__item--reveal');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-quality"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--quality');
  if (!sectionEl) return;
  var parts = sectionEl.querySelectorAll('[data-kk-quality-part]');
  if (!parts.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealParts() {
    parts.forEach(function(part, i) {
      setTimeout(function() {
        part.classList.add('kk-quality--visible');
      }, 300 + (i * 250));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealParts();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealParts();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--rev');
  if (!sectionEl) return;

  var trustBar = sectionEl.querySelector('[data-kk-rev-trust]');
  var cards = sectionEl.querySelectorAll('[data-kk-rev-card]');
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced) return;

  function revealSequence() {
    /* Trust-Bar zuerst (300ms nach Section-Reveal) */
    if (trustBar) {
      setTimeout(function() {
        trustBar.classList.add('kk-rev__trust--visible');
      }, 300);
    }

    /* Cards gestaffelt (500ms Basis + 120ms pro Card) */
    cards.forEach(function(card, i) {
      setTimeout(function() {
        card.classList.add('kk-rev__item--visible');
      }, 500 + (i * 120));
    });
  }

  /* Auf globalen Scroll-Reveal reagieren (kk-visible) */
  if (sectionEl.classList.contains('kk-visible')) {
    revealSequence();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealSequence();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* Mobile: Scroll-Fade am Ende ausblenden */
  var grid = sectionEl.querySelector('.kk-rev__grid');
  var wrap = sectionEl.querySelector('.kk-rev__grid-wrap');
  if (wrap && grid && window.innerWidth <= 749) {
    grid.addEventListener('scroll', function() {
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
      wrap.classList.toggle('kk-rev__grid-wrap--scrolled-end', atEnd);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-trust-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--trust');
  if (!sectionEl) return;
  var items = sectionEl.querySelectorAll('[data-kk-trust-item]');
  if (!items.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealItems() {
    items.forEach(function(item, i) {
      setTimeout(function() {
        item.classList.add('kk-trust__item--visible');
      }, 300 + (i * 130));
    });

    /* v2.4.2: Strich fadet mit der zweiten Stimme, Punkte + Label als Abschluss */
    var rule = sectionEl.querySelector('.kk-trust__rule');
    var dots = sectionEl.querySelector('.kk-trust__dots');
    var label = sectionEl.querySelector('.kk-trust__label');
    var tail = 300 + (items.length * 130);
    if (rule) {
      setTimeout(function() { rule.classList.add('kk-trust__fade-in'); }, 430);
    }
    [dots, label].forEach(function(el) {
      if (el) {
        setTimeout(function() { el.classList.add('kk-trust__fade-in'); }, tail);
      }
    });
  }

  /* Auf den globalen Scroll-Reveal (kk-visible, Custom-Liquid-Block v9) reagieren */
  if (sectionEl.classList.contains('kk-visible')) {
    revealItems();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealItems();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-umfrage"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REVISION = '2026-07-15';
  var MIN_SECONDS_BEFORE_SUBMIT = 4;

  function initSurvey(root) {
    var form = root.querySelector('.kk-umfrage__form');
    var thanks = root.querySelector('.kk-umfrage__thanks');
    var formArea = root.querySelector('.kk-umfrage__form-area');
    if (!form || !thanks || !formArea || form.dataset.kkInit) return;
    form.dataset.kkInit = '1';

    var submitButton = form.querySelector('button[type="submit"]');
    var designMode = window.Shopify && window.Shopify.designMode;
    var storageKey = 'kk-umfrage-done-' + root.dataset.surveyId;
    var startedAt = Date.now();

    // pid aus der URL lesen (kommt aus der E-Mail-Kampagne). Nie anzeigen, nie loggen.
    var pid = new URLSearchParams(window.location.search).get('pid') || '';
    if (!/^[A-Za-z0-9_-]{6,64}$/.test(pid)) pid = '';

    // pid sofort aus der Adresszeile entfernen, damit Analytics-Tools (Matomo/Clarity)
    // sie nicht in Seiten-URLs mitschreiben. Bleibt bis zum Reload im Speicher.
    if (pid) {
      try {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('pid');
        window.history.replaceState(null, '', cleanUrl.toString());
      } catch (e) { /* egal */ }
    }

    var emailWrap = root.querySelector('.kk-umfrage__email');
    if (!pid && emailWrap) emailWrap.hidden = false;

    function alreadyDone() {
      try { return localStorage.getItem(storageKey) === '1'; } catch (e) { return false; }
    }
    function markDone() {
      try { localStorage.setItem(storageKey, '1'); } catch (e) { /* egal */ }
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // kk-Signatur "Earned Attention": Fragen faden einmalig beim Scrollen ein (farbsystem-Spez)
    if (!reducedMotion && 'IntersectionObserver' in window) {
      root.classList.add('kk-umfrage--animate');
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kk-umfrage__q--visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      form.querySelectorAll('.kk-umfrage__q').forEach(function (q) { revealObserver.observe(q); });

      // Fokus schlaegt Animation: Wer in ein noch einfadendes Feld klickt/einfuegt,
      // sieht seine Eingabe sofort (kein Mit-Einfaden des getippten/eingefuegten Texts).
      form.addEventListener('focusin', function (event) {
        var q = event.target.closest('.kk-umfrage__q');
        if (q && !q.classList.contains('kk-umfrage__q--visible')) {
          q.classList.add('kk-umfrage__q--instant');
          q.classList.add('kk-umfrage__q--visible');
          revealObserver.unobserve(q);
        }
      });
    }

    function showThanks(withScroll) {
      var swap = function () {
        formArea.hidden = true;
        thanks.hidden = false;
        if (!reducedMotion) thanks.classList.add('kk-umfrage__thanks--reveal');
        if (withScroll) root.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
      };
      // Beim echten Absenden: Formular sanft ausblenden, dann Danke einblenden.
      // Wiederbesuch (withScroll=false) und reduced-motion: sofortiger Wechsel.
      if (!reducedMotion && withScroll) {
        formArea.classList.add('kk-umfrage__form-area--fade');
        window.setTimeout(swap, 300);
      } else {
        swap();
      }
    }

    if (!designMode && alreadyDone()) {
      showThanks(false);
      return;
    }

    // Absenden erst aktiv, wenn alle Pflichtfragen beantwortet sind
    function requiredComplete() {
      var required = form.querySelectorAll('.kk-umfrage__q[data-required]');
      for (var i = 0; i < required.length; i++) {
        var q = required[i];
        if (q.dataset.type === 'text') {
          var field = q.querySelector('textarea');
          if (!field || !field.value.trim()) return false;
        } else if (q.dataset.type === 'dropdown') {
          var select = q.querySelector('select');
          if (!select || !select.value) return false;
        } else if (!q.querySelector('input:checked')) {
          return false;
        }
      }
      return true;
    }

    function syncButton() {
      if (submitButton) submitButton.disabled = !requiredComplete();
    }

    form.addEventListener('change', syncButton);
    form.addEventListener('input', syncButton);
    syncButton();

    function collectAnswers() {
      var eventProps = {};
      var profileProps = {};

      form.querySelectorAll('.kk-umfrage__q').forEach(function (q) {
        var question = q.dataset.question;
        if (!question) return; // E-Mail-/Sonderfelder
        var prop = (q.dataset.prop || '').trim();
        var type = q.dataset.type;
        var value = null;

        if (type === 'scale' || type === 'stars') {
          var checkedScale = q.querySelector('input:checked');
          if (checkedScale) value = Number(checkedScale.value);
        } else if (type === 'dropdown') {
          var selectField = q.querySelector('select');
          if (selectField && selectField.value) value = selectField.value;
        } else if (type === 'multi') {
          var values = Array.prototype.map.call(q.querySelectorAll('input:checked'), function (input) {
            return input.value;
          });
          if (values.length) value = values;
        } else if (type === 'single') {
          var checkedSingle = q.querySelector('input:checked');
          if (checkedSingle) value = checkedSingle.value;
        } else if (type === 'text') {
          var field = q.querySelector('textarea');
          if (field && field.value.trim()) value = field.value.trim();
        }

        if (value === null) return;
        eventProps[prop || question] = value;
        if (prop) profileProps[prop] = value; // Freitexte haben bewusst kein Property -> nur Event
      });

      return { eventProps: eventProps, profileProps: profileProps };
    }

    function randomId() {
      try { return window.crypto.randomUUID(); } catch (e) {
        return 'anon-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      }
    }

    function klaviyoPost(path, payload) {
      var url = 'https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(root.dataset.publicKey);
      return fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) console.error('[kk-umfrage] Klaviyo ' + path + ': HTTP ' + response.status);
      }).catch(function (error) {
        console.error('[kk-umfrage] Klaviyo ' + path + ' nicht erreichbar', error);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!requiredComplete()) return;
      if (submitButton) submitButton.disabled = true;

      // Spam-Gates: Honeypot gefuellt oder zu schnell abgeschickt -> still verwerfen
      var honeypot = form.querySelector('input[name="website"]');
      var tooFast = Date.now() - startedAt < MIN_SECONDS_BEFORE_SUBMIT * 1000;
      if ((honeypot && honeypot.value) || tooFast) {
        showThanks(true);
        return;
      }

      var email = '';
      if (!pid) {
        var emailInput = form.querySelector('input[type="email"]');
        if (emailInput && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) {
          email = emailInput.value.trim();
        }
      }

      var answers = collectAnswers();
      var dateProp = (root.dataset.dateProp || '').trim();
      if (dateProp && (pid || email)) {
        answers.profileProps[dateProp] = new Date().toISOString();
      }
      answers.eventProps['Zuordnung'] = pid ? 'Profil-ID' : (email ? 'E-Mail' : 'anonym');

      // Event-Profil: immer genau ein Identifier (pid > E-Mail > generierte anonymous_id)
      var eventProfile = { type: 'profile', attributes: {} };
      if (pid) eventProfile.id = pid;
      else if (email) eventProfile.attributes.email = email;
      else eventProfile.attributes.anonymous_id = randomId();

      var eventPayload = {
        data: {
          type: 'event',
          attributes: {
            properties: answers.eventProps,
            metric: { data: { type: 'metric', attributes: { name: root.dataset.metric } } },
            profile: { data: eventProfile },
            unique_id: 'kk-umfrage-' + root.dataset.surveyId + '-' + (pid || email || randomId()) + '-' + new Date().toISOString().slice(0, 10)
          }
        }
      };

      if (designMode) {
        console.info('[kk-umfrage] Design-Modus: Klaviyo-Calls uebersprungen.');
        showThanks(true);
        return;
      }

      // 1) Profil-Properties (nur mit Zuordnung), 2) Event. Fire-and-forget:
      // Dankesansicht kommt sofort, Fehler landen nur in der Konsole.
      if ((pid || email) && Object.keys(answers.profileProps).length) {
        var profileData = { type: 'profile', attributes: { properties: answers.profileProps } };
        if (pid) profileData.id = pid;
        else profileData.attributes.email = email;
        klaviyoPost('profiles', { data: profileData });
      }
      klaviyoPost('events', eventPayload);

      markDone();
      showThanks(true);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.kk-umfrage').forEach(initSurvey);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-usps"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--usps');
  if (!sectionEl) return;
  var items = sectionEl.querySelectorAll('[data-kk-usps-item]');
  if (!items.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealItems() {
    items.forEach(function(item, i) {
      setTimeout(function() {
        item.classList.add('kk-usps__item--visible');
      }, 300 + (i * 80));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealItems();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealItems();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* Mobile: Scroll-Fade am Ende ausblenden */
  var grid = sectionEl.querySelector('.kk-usps__grid');
  var wrap = sectionEl.querySelector('.kk-usps__grid-wrap');
  if (wrap && grid && window.innerWidth <= 749) {
    grid.addEventListener('scroll', function() {
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
      wrap.classList.toggle('kk-usps__grid-wrap--scrolled-end', atEnd);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
